import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { ChartJs } from '../../lib';
import { ThemeContext } from '../../context/ThemeContext';
import { LangContext } from '../../context/LangContext';
import Utils from '../../utils';

const pluginRefs = { datalabels: ChartDataLabels };

function DoughnutChart({
  data,
  options,
  wrapperClassName,
  chartClassName,
  height,
  plugins,
}) {
  const { theme } = useContext(ThemeContext);
  const { currentLanguage } = useContext(LangContext);

  const getPlugins = () => {
    const plgs = [];
    if (Object.keys(plugins).length > 0) {
      Object.keys(plugins).forEach((key) => {
        if (plugins[key]) {
          plgs.push(pluginRefs[key]);
        }
      });
    }

    return plgs;
  };

  return (
    <div className={wrapperClassName} style={{ height }}>
      <ChartJs.Charts.Doughnut
        className={chartClassName}
        data={data}
        options={Utils.Chart.getDoughnutChartDefaultOptions(
          options,
          theme,
          plugins
        )}
        plugins={getPlugins()}
        lang={currentLanguage}
      />
    </div>
  );
}

DoughnutChart.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  options: PropTypes.objectOf(PropTypes.any),
  wrapperClassName: PropTypes.string,
  chartClassName: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  plugins: PropTypes.shape({ datalabels: PropTypes.bool }),
};

DoughnutChart.defaultProps = {
  options: {},
  wrapperClassName: 'chartjs-custom w-100',
  chartClassName: 'js-chart-doughnut',
  height: '20rem',
  plugins: { datalabels: false },
};

export default DoughnutChart;
